__turbopack_context__.v({
  "container": "dqYZrW_container",
  "icon": "dqYZrW_icon",
  "text": "dqYZrW_text",
});
